import * as React from 'react';
import { Grid } from '@mui/material';
import { AutoBulkTransaction } from '../model';
import TransactionDetails from './TransactionDetails';
import TreatmentProductInformation from './ProductInformation';

type SideBarContentProps = {
  transaction: AutoBulkTransaction;
};

const SidebarContent: React.FC<SideBarContentProps> = (props) => {
  const { transaction } = props;

  return (
    <>
      <Grid
        justifyContent="space-between"
        container
        spacing={3}
        style={{ marginLeft: '0px', marginTop: '0px', paddingRight: '50px' }}
      >
        <Grid item xs={12}>
          <TransactionDetails transaction={transaction} />
        </Grid>
        <br />
        <Grid item xs={12} style={{ marginTop: '0px' }}>
          <TreatmentProductInformation transaction={transaction} />
        </Grid>
      </Grid>
    </>
  );
};

export default SidebarContent;
